export default __webpack_public_path__ + "static/media/meeting-ending.461a4e68.mp3";